import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import React, { useContext, useState, useEffect, Fragment } from "react";
import EditIcon from '@mui/icons-material/Edit';
import { APIContext } from "src/components/Contexts/APIContext"

interface IEditScorecardButtonProps {
    completeId: number;
    editCompletedScorecard: () => void;
}

export default function EditScorecardButton(props: IEditScorecardButtonProps) {
    const { isTeamLeader, get } = useContext(APIContext);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (isTeamLeader) {
            get('MonitoringScorecard', `IsUsersScorecard?completeId=${props.completeId}`, (data) => setShow(data))
        }
        else {
            setShow(true);
        }
    }, [])

    return (
        show ?
            <Grid>
                <Button
                    onClick={props.editCompletedScorecard}>
                    <Tooltip
                        title="Edit Scorecard"
                        placement="bottom">
                        <EditIcon
                            color="primary"
                            fontSize="medium" />
                    </Tooltip>
                </Button>
            </Grid>
            :
            <Fragment />
    )
}